import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { DecorPickerList } from "./DecorPickerList";

// Popover obálka nad sdíleným seznamem dekorů (§E/§F).
export function DecorPicker({ decors, value, onPick, preferredCategory, onPickCustom, customCurrent, onClearCustom, mixedMessage, open, onOpenChange, trigger, testid }) {
  return (
    <Popover open={open} onOpenChange={onOpenChange}>
      <PopoverTrigger asChild>{trigger}</PopoverTrigger>
      <PopoverContent align="start" sideOffset={6}
        className="w-[340px] p-0 rounded-[14px] shadow-[0_16px_40px_rgba(0,0,0,0.16)]" data-testid={testid}>
        <DecorPickerList decors={decors} value={value} onPick={onPick} preferredCategory={preferredCategory}
          onPickCustom={onPickCustom} customCurrent={customCurrent} onClearCustom={onClearCustom} mixedMessage={mixedMessage} />
      </PopoverContent>
    </Popover>
  );
}
